﻿import { NamedValueResponse } from '../../../shared/models/named-value-response.model'

export class Service extends NamedValueResponse {
    constructor(id: number, name: string,public warnings: string) {
        super(id, name);
    }
}